<template>
  <div class="centerBox">
    <!-- 头部 -->
    <div class="BoxHead">
      <!-- 返回 -->
      <div class="headLeft">
        <div class="leftJt" @click="toBack">
          <svg-btn class="leftIcon" icon-class="icon-left"></svg-btn>
        </div>
        <div class="headright">个人主页</div>
      </div>
      <!-- 个人信息  -->
      <div class="userInfoBox" v-show="!headLoading">
        <div class="infoLeft">
          <el-image class="imgOne" :src="upInfo.logo" fit="cover">
            <img
              width="72"
              height="72"
              slot="error"
              class="error-headImg"
              :src="$utils.getPng('icon-gfans-defaultHead')"
            />
          </el-image>
          <div class="leftOne">
            <div class="ufont1">{{ upInfo.nickname }}</div>
            <div class="rightOne" v-show="isUpOpen">
              <div class="ufont2">获赞与收藏</div>
              <div class="ufont3">{{ upInfo.likes }}</div>
              <div class="line"></div>
              <div class="ufont2">订阅</div>
              <div class="ufont3">{{ upInfo.fans }}</div>
            </div>
          </div>
        </div>
        <!-- upInfo.is_self == 1是自己，else是他人 -->
        <div
          @click="checkDy()"
          v-show="upInfo.is_self != 1"
          :class="{
            releaseBtn: true,
            primaryBtn: upInfo.is_follow != 1,
            releaseBtn2: upInfo.is_follow == 1,
            textBtn: upInfo.is_follow == 1,
          }"
        >
          {{
            isUpOpen
              ? upInfo.is_follow == 1
                ? '已订阅'
                : '订阅'
              : '开通订阅号'
          }}
        </div>
      </div>
      <!-- 搜索输入框 -->
      <div class="inputBox" v-show="!headLoading && isUpOpen">
        <el-input
          class="commitInput"
          resize="none"
          autosize
          @keydown.enter.native="search"
          placeholder="关键词搜索"
          v-model="keyword"
        >
        </el-input>
        <svg-btn
          @click="search"
          class="inputIcon"
          icon-class="icon-search"
        ></svg-btn>
      </div>
      <!-- tab组件切换 -->
      <TabCheck
        v-if="!headLoading && isUpOpen"
        style="margin-bottom: 16px"
        :defaultActive="defaultActive"
        :tabs="tabs"
        @tab-change="handleTabChange"
      />
      <!-- 头部骨架屏 -->
      <div class="boxHeadSkeleton" v-show="headLoading">
        <div class="headLeftSkeleton">
          <div class="leftJtSkeleton"></div>
          <div class="headrightSkeleton"></div>
        </div>
        <div class="userInfoBoxSkeleton">
          <div class="infoLeftSkeleton">
            <div class="imgOneSkeleton"></div>
            <div class="leftOneSkeleton">
              <div class="ufont1Skeleton"></div>
              <div class="rightOneSkeleton">
                <div class="statSkeleton"></div>
                <div class="lineSkeleton"></div>
                <div class="statSkeleton"></div>
              </div>
            </div>
          </div>
          <div class="releaseBtnSkeleton"></div>
        </div>
        <div class="inputBoxSkeleton" v-show="isUpOpen"></div>
        <div class="tabCheckSkeleton" v-show="isUpOpen"></div>
      </div>
    </div>
    <!-- 列表骨架屏 -->
    <div v-show="loading" class="skeleton-container">
      <div class="skeleton-item" v-for="i in 3" :key="i">
        <div class="skeleton-head">
          <div class="skeleton-avatar"></div>
          <div class="skeleton-info">
            <div class="skeleton-line line-1"></div>
            <div class="skeleton-line line-2"></div>
          </div>
        </div>
        <div class="skeleton-title"></div>
        <div class="skeleton-image"></div>
        <div class="skeleton-desc"></div>
        <div class="skeleton-actions">
          <div class="skeleton-btn"></div>
          <div class="skeleton-btn"></div>
          <div class="skeleton-btn"></div>
        </div>
      </div>
    </div>
    <!-- 主体内容 -->
    <FmContent
      ref="fmContent"
      v-show="!loading && isUpOpen && total > 0"
      :arrList="arrList"
      :isLoading="isLoading"
      :isFind="true"
      :isType="3"
      :noMoreData="noMoreData"
      @updataUp="updataUp"
      @load-more="handleLoadMore"
    />
    <div class="noneData" style="top: 268px" v-show="isInitialEmpty">
      <img
        class="noneIcon"
        :src="
          $utils.getPng(
            $store.state.theme == 'light'
              ? 'icon-gfans-none'
              : 'icon-gfans-none-dark'
          )
        "
      />
      <div class="font2">暂无内容</div>
    </div>
    <!-- 未找到该关键词内容 -->
    <div class="noneData" style="top: 268px" v-show="isSearchEmpty">
      <img
        class="noneIcon"
        :src="
          $utils.getPng(
            $store.state.theme == 'light'
              ? 'icon-gfans-noSearch'
              : 'icon-gfans-noSearch-dark'
          )
        "
      />
      <div class="font2">未找到该关键词内容</div>
    </div>
    <!-- 未开通订阅号 -->
    <div class="noneData" style="top: 164px" v-show="!isUpOpen">
      <img
        class="noneIcon"
        :src="
          $utils.getPng(
            $store.state.theme == 'light'
              ? 'icon-gfans-noUp'
              : 'icon-gfans-noUp-dark'
          )
        "
      />
      <div class="font1">你还未开通订阅号</div>
      <div class="font2">快来让更多人看见你的分享</div>
      <div @click="checkDy()" class="releaseBtn primaryBtn">开通订阅号</div>
      <div class="openBox">
        <div class="open" v-for="(item, index) in openList" :key="index">
          <img
            class="imgO"
            :src="
              $utils.getPng(
                $store.state.theme == 'light' ? item.img : item.img + '-dark'
              )
            "
          />
          <div class="openF">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <PromptTip
      @confirm="confirm"
      @handleClose="handleClose"
      tips="确认取消订阅该订阅号？"
      :isShow="isShow"
    />
  </div>
</template>

<script>
import { getUserList, getUserInfo } from '@/axios/user'
import { checkModirlt } from '@/axios/home'
import PromptTip from '@/components/PromptTip/index'
import TabCheck from '@/components/TabCheck/index'
import FmContent from '@/components/FmContent/index'
import { eventBus } from '@/utils/event-bus'
import { scrollPosCache } from '@/utils/scrollCache'
export default {
  name: 'user',
  components: {
    TabCheck,
    FmContent,
    PromptTip,
  },
  data() {
    return {
      tabs: [
        { id: 0, name: '全部' },
        { id: 1, name: '帖子' },
        { id: 2, name: '短视频' },
      ],
      openList: [
        {
          img: 'icon-gfans-openOne',
          name: '开通订阅号',
        },
        {
          img: 'icon-gfans-openTwo',
          name: '发布帖子关联资源',
        },
        {
          img: 'icon-gfans-openThree',
          name: '让更多人看见你的分享',
        },
      ],
      upInfo: {}, //订阅号信息
      keyword: '',
      defaultActive: 0,
      arrList: [],
      headLoading: true,
      loading: true,
      isLoading: false,
      noMoreData: false,
      page: 1,
      limit: 30,
      total: null,
      isShow: false, //消息提示
      isUpOpen: true, //是否开通了订阅号
      is_keyword: 0, // 是否已执行搜索
      watcher: null, // 存储监听器取消函数
    }
  },
  beforeRouteLeave(to, from, next) {
    scrollPosCache[from.path] = window.pageYOffset
    next()
  },
  activated() {
    // 组件激活
    const savedPos = scrollPosCache[this.$route.path]
    let num = savedPos !== undefined ? savedPos : 0
    this.$nextTick(() => {
      window.scrollTo(0, num)
    })
    // 组件被重新激活时，重新创建监听器
    if (!this.watcher) {
      const callback = () => {
        this.resetPageState()
        this.getUserInfo()
      }
      this.watcher = this.$watch('$route.params.uid', callback)
      callback(this.$route.params.uid, undefined)
    }
  },
  deactivated() {
    // 组件被缓存时取消监听器
    if (this.watcher) {
      this.watcher() // 执行取消函数
      this.watcher = null // 重置引用
    }
  },
  computed: {
    // 计算属性：判断是否为初始无数据状态
    isInitialEmpty() {
      return (
        !this.loading &&
        this.isUpOpen &&
        this.total == 0 &&
        this.is_keyword == 0
      )
    },

    // 计算属性：判断是否为搜索无结果状态
    isSearchEmpty() {
      return (
        !this.loading &&
        this.isUpOpen &&
        this.total == 0 &&
        this.is_keyword == 1
      )
    },
  },
  mounted() {
    // 监听更新个人主页数据事件
    eventBus.$on('upUserList', () => {
      this.$nextTick(() => {
        this.getUserInfo(1)
        //只有查看别人的主页才需要去子组件更新订阅状态，自己主页是没有订阅状态的
        if (this.upInfo.is_self != 1) {
          this.$refs.fmContent.frontEndUp(this.upInfo.uid)
        }
      })
    })
    eventBus.$on('itemUpdated', this.updateListItem)
  },
  beforeDestroy() {
    if (this.watcher) {
      this.watcher()
    }
    eventBus.$off('itemUpdated')
    eventBus.$off('upUserList')
  },
  methods: {
    async getUserInfo(row) {
      try {
        let res = await getUserInfo({
          uid: this.$route.params.uid,
        })
        if (res.status == 1) {
          document.title = res.data.nickname + ' - Gfans'
          this.upInfo = res.data
          if (!row) {
            await this.fetchData()
          }
        } else if (res.status == 402002) {
          //未开通订阅号
          this.upInfo = res.data
          this.headLoading = false
          this.loading = false
          this.isUpOpen = false
        } else {
          this.$toast(res.msg, 2)
        }
      } catch (error) {}
    },
    //数据初始化
    async fetchData() {
      if (this.isLoading || this.noMoreData) return
      this.isLoading = true
      try {
        let data = {
          uid: this.$route.params.uid,
          page: this.page,
          limit: this.limit,
          sourceType: this.defaultActive, //0:查看全部 1-文章 2-视频
          keyword: this.keyword.trim(),
        }
        let res = await getUserList(data)
        if (res.status == 1) {
          // 处理vhtml字段
          const processedList = res.data.list.map(item => {
            // 复制原始数据
            const newItem = { ...item }
            // 处理vhtml
            if (item.vhtml) {
              newItem.vhtml = item.vhtml
                .replace(/<(?!\/?(img|font|p|div)|[! ])[^>]*>/g, '')
                .replace(
                  /<font([^>]*)\ssize\s*=\s*["'][^"']*["']([^>]*)>/gi,
                  '<font$1$2>'
                )
            }
            return newItem
          })
          this.arrList =
            this.page == 1
              ? [...processedList] // 首页直接赋值
              : [...this.arrList, ...processedList] // 后续页追加数据
          this.total = Number(res.data.total)
          this.is_keyword = res.data.is_keyword
          this.noMoreData = this.arrList.length >= this.total
          this.page++
        } else if (res.status == 402002) {
          //未开通订阅号
          this.upInfo = res.data
          this.isUpOpen = false
        } else {
          this.is_keyword = 1
          this.total = 0
          this.$toast(res.msg, 2)
        }
        this.headLoading = false
        this.loading = false
      } catch {
        this.noMoreData = true
      } finally {
        this.isLoading = false
      }
    },
    //加载更多
    handleLoadMore() {
      this.fetchData()
    },
    resetPageState() {
      this.scrollToTop()
      this.keyword = ''
      this.isUpOpen = true
      this.page = 1
      this.loading = true
      this.noMoreData = false
      this.isLoading = false
      this.arrList = []
    },
    updateListItem(updatedData) {
      // 解构出匹配条件和需要更新的字段
      const { fshort, userid, ...fields } = updatedData

      // 定义匹配函数（根据传入的条件决定使用fshort还是userid）
      const matchFn = item => {
        if (fshort !== undefined) {
          return item.fshort == fshort
        } else if (userid !== undefined) {
          return item.userid == userid
        }
        return false // 必须提供至少一个匹配条件
      }

      // 找到所有匹配的元素（支持多个结果）
      const matchedItems = this.arrList
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => matchFn(item))

      // 批量更新所有匹配的元素
      matchedItems.forEach(({ item, index }) => {
        const updatedItem = { ...item, ...fields }
        this.$set(this.arrList, index, updatedItem)
      })

      // 返回更新的数量（可选，用于调试）
      return matchedItems.length
    },
    //搜索
    search: _.debounce(
      function () {
        this.loading = true
        this.isLoading = false
        this.noMoreData = false
        this.arrList = []
        this.page = 1
        this.limit = 30
        this.fetchData()
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //切换类型
    handleTabChange(row) {
      this.scrollToTop()
      this.defaultActive = row
      this.loading = true
      this.isLoading = false
      this.noMoreData = false
      this.arrList = []
      this.page = 1
      this.limit = 30
      this.fetchData()
    },
    // 回到顶部
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    //返回上一页
    toBack() {
      if (this.$store.state.isLogin == 0) {
        this.$router.push({ path: '/discover' })
      } else {
        this.$router.push({ path: '/subscribe' })
      }
    },
    //取消订阅
    confirm: _.debounce(
      function () {
        checkModirlt({
          uid: this.upInfo.uid,
          act: 2,
        }).then(res => {
          if (res.status == 1) {
            this.$nextTick(() => {
              this.getUserInfo(1)
              eventBus.$emit('upHotList')
              this.updateHomePage({
                userid: this.upInfo.uid,
                is_follow: 0,
              })
              this.$refs.fmContent.frontEndUp(this.upInfo.uid)
            })
            this.handleClose()
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),

    //关闭取消订阅弹窗
    handleClose() {
      this.isShow = false
    },
    //子组件点击了订阅
    updataUp() {
      //刷新用户信息
      this.getUserInfo(1)
    },
    checkDy() {
      if (!this.isUpOpen) {
        //开通订阅号
        window.open(
          this.$glb.upJmdyhUrl +
            `/subscribe?platfro=${localStorage.getItem('platfro')}`,
          '_blank'
        )
        return
      }
      if (this.upInfo.is_follow == 1) {
        this.isShow = true
      } else {
        checkModirlt({
          uid: this.upInfo.uid,
          act: 1,
        }).then(res => {
          if (res.status == 1) {
            this.$nextTick(() => {
              this.getUserInfo(1)
              eventBus.$emit('upHotList')
              this.updateHomePage({
                userid: this.upInfo.uid,
                is_follow: 1,
              })
              this.$refs.fmContent.frontEndUp(this.upInfo.uid)
            })
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      }
    },
    // 批量更新多个字段并通知中间页面
    updateHomePage(updatedFields) {
      // 合并需要更新的字段
      const dataToUpdate = {
        userid: updatedFields.userid,
        ...updatedFields,
      }
      // 发送事件通知页面更新
      eventBus.$emit('itemUpdated', dataToUpdate)
    },
  },
}
</script>

<style lang="scss" scoped>
.centerBox {
  margin-top: -72px;
  .BoxHead {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    // position: fixed;
    position: sticky;
    top: 0;
    z-index: 400;
    max-width: 600px;
    width: 100%;
    @include useTheme {
      background: getVar('bg-color');
    }
    .headLeft {
      display: flex;
      align-items: center;
      height: 72px;
      min-height: 72px;
      width: 100%;
      .avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
      }

      .headImg {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .leftJt {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 12px;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
        .leftIcon {
          width: 18px;
          height: 18px;
        }
        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
    }
    .headright {
      max-width: 536px;
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }
  }
  .userInfoBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    margin-bottom: 20px;
    .infoLeft {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .imgOne {
        width: 72px;
        height: 72px;
        object-fit: cover;
        border-radius: 50%;
      }
      .leftOne {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 16px;
        .ufont1 {
          font-weight: 600;
          font-size: 18px;
          line-height: 26px;
          margin-bottom: 4px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
        .rightOne {
          display: flex;
          align-items: center;
          justify-content: center;
          .ufont2 {
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-right: 6px;
            flex-shrink: 0;
            @include useTheme {
              color: getVar('text-color2-75787b');
            }
          }
          .ufont3 {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            @include multiline(1);
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .line {
            width: 1px;
            height: 12px;
            margin: 0 12px;
            @include useTheme {
              background: getVar('border-color3-dadada');
            }
          }
        }
      }
    }
    .releaseBtn {
      padding: 5px 23px;
      height: 32px;
      border-radius: 18px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 22px;
      margin-right: 16px;
      flex-shrink: 0;
    }
    .releaseBtn2 {
      padding: 0 !important;
      width: 74px !important;
      background: transparent !important;
      @include useTheme {
        color: getVar('text-color2-75787b') !important;
      }
    }
  }
  .inputBox {
    position: relative;
    width: 100%;

    margin-bottom: 20px;
    ::v-deep .commitInput {
      .el-input__inner {
        height: 40px !important;
        border-radius: 20px;
        padding: 9px 40px 9px 16px !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        border: 1px solid transparent;
        white-space: pre-wrap;
        word-break: break-all;
        overflow-y: auto !important;
        // transition: padding-left 0.2s;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
          caret-color: getVar('primary-color');
          background: getVar('bg-color2-f4f6f8');
        }
        &::placeholder {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          @include useTheme {
            color: getVar('text-color6-b8bec4');
          }
        }
        &:hover {
          @include useTheme {
            border: 1px solid getVar('primary-color');
          }
        }
        &:focus {
          transition: padding-left 0.2s;
          padding-left: 16px;
          @include useTheme {
            outline: 2px solid getVar('primary-color4');
            border: 1px solid getVar('primary-color');
            background: getVar('bg-color-content');
          }
        }
      }
    }
    .inputIcon {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      @include useTheme {
        color: getVar('text-color6-b8bec4');
      }
    }
  }
  .noneData {
    position: fixed;
    padding: 148px 16px 16px 16px !important;
    .releaseBtn {
      padding: 8px 24px;
      height: 40px;
      border-radius: 20px;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 24px;
      margin-top: 24px;
      margin-bottom: 88px;
      flex-shrink: 0;
    }
    .openBox {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      padding: 32px 38px 34px 38px;
      position: relative;
      .open {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 140px;
        .imgO {
          width: 52px;
          height: 52px;
        }
        .openF {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          margin-top: 10px;
          text-align: center;
          @include useTheme {
            color: getVar('text-color2-75787b');
          }
        }
      }
    }
    @media (max-width: 739px) {
      .openBox {
        padding: 0 !important;
        .open {
          margin-right: 15px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .boxHeadSkeleton {
    position: sticky;
    top: 0;
    z-index: 300;
    max-width: 600px;
    width: 100%;
    @include useTheme {
      background: getVar('bg-color');
    }
    box-sizing: border-box;
    animation: skeletonFade 1.5s infinite ease-in-out;
  }

  .userInfoBoxSkeleton {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
  }

  .infoLeftSkeleton {
    display: flex;
    align-items: center;
  }

  .imgOneSkeleton {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
    margin-right: 16px;
  }

  .leftOneSkeleton {
    display: flex;
    flex-direction: column;
  }

  .ufont1Skeleton {
    height: 26px;
    width: 200px;
    border-radius: 13px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
    margin-bottom: 10px;
  }

  .rightOneSkeleton {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }

  .statSkeleton {
    height: 22px;
    width: 30px;
    border-radius: 11px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .lineSkeleton {
    width: 1px;
    height: 12px;
    @include useTheme {
      background: getVar('border-color3-dadada');
    }
    margin: 0 12px;
  }

  .releaseBtnSkeleton {
    width: 74px;
    height: 32px;
    border-radius: 16px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .inputBoxSkeleton {
    height: 40px;
    border-radius: 20px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
    margin-bottom: 20px;
    position: relative;
  }

  .inputBoxSkeleton::after {
    content: '';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
    border-radius: 50%;
  }

  .tabCheckSkeleton {
    width: 20%;
    height: 32px;
    margin-bottom: 16px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
    border-radius: 16px;
  }

  /* 骨架屏动画 */
  @keyframes skeletonFade {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
  /* 骨架屏样式 */
  .skeleton-container {
    height: 100%;
    border-radius: 16px 16px 0px 0px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
  }
  .skeleton-item {
    border-radius: 16px;
    margin-bottom: 16px;
    padding: 16px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    &:nth-child(even) {
      animation: pulse 1.5s infinite ease-in-out;
    }

    &:nth-child(odd) {
      animation: pulse 1.5s 0.3s infinite ease-in-out;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .skeleton-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .skeleton-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-info {
    margin-left: 12px;
    flex: 1;
  }

  .skeleton-line {
    height: 16px;
    border-radius: 8px;
    margin-bottom: 6px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .line-1 {
    width: 60%;
  }

  .line-2 {
    width: 40%;
  }

  .skeleton-title {
    height: 24px;
    border-radius: 12px;
    margin-bottom: 12px;
    width: 80%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-image {
    height: 150px;
    border-radius: 16px;
    margin-bottom: 12px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-desc {
    height: 42px;
    border-radius: 8px;
    margin-bottom: 16px;
    width: 90%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-actions {
    display: flex;
    justify-content: space-around;
  }

  .skeleton-btn {
    width: 80px;
    height: 32px;
    border-radius: 16px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
}
</style>
